import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Drawer, Dropdown, Table } from "antd";
import { useEffect, useState } from "react";
import { AiFillPlusCircle, AiOutlineQuestionCircle } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import { MdMyLocation } from "react-icons/md";
import { PiSealCheck } from "react-icons/pi";
import { RiRefreshLine } from "react-icons/ri";
import { SlOptionsVertical } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import imagePlaceholder from "../../../../assets/images/imageplace.jpg";
import md1 from "../../../../assets/images/staticImages/c1.png";
import md2 from "../../../../assets/images/staticImages/c2.png";
import md3 from "../../../../assets/images/staticImages/c3.png";
import md4 from "../../../../assets/images/staticImages/c4.png";
import md5 from "../../../../assets/images/staticImages/c5.png";
import {
  Modal,
  SubmitButton,
  TextComponent,
  Dropdown as Drop,
} from "../../../../components";
import Card from "../../../../components/Card/Card";
import FloatingButton from "../../../../components/floatingButton/FloatBtn";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import AddAssets from "../AddAssets/AddAssets";
import AddGroupAssetModal from "../AddGroupAsset/AddGroupAsset";
import EditAssets from "../EditAsset/EditAsset";
import styles from "../SingleAssets/singleasset.module.css";
import UploadAssets from "../UploadAsset/UploadAsset";
import ConnectModule from "./ConnectModule/ConnectModule";

const Unlink = ({
  add_asset,
  is_immobilized,
  user,
  setActiveTab,
  pair_unpair_device,
  isPending,
}) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const [afterDispatch, setAfterDispatch] = useState(true);
  const [details, setDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [connectModal, setConnectModal] = useState(false);
  const [openAddAssetsModal, setOpenAddAssetsModal] = useState(false);
  const [openEditAssetsModal, setOpenEditAssetsModal] = useState(false);
  const [openAddGroupAsset, setOpenAddGroupAsset] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openUploadAsset, setOpenUploadAsset] = useState(false);
  const [activePending, setActivePending] = useState(isPending);

  const getUnlinkAssets = useSelector(
    (state) => state.AssetsReducer.getUnlinkAssets,
  );

  const reports = user?.permissions?.find((x) => x?.name == "reports");
  const lot_name = user?.permissions?.find((x) => x?.name == "lot_name");
  const lot_numbers = useSelector((state) => state.PagesReducer?.lot_numbers);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setActivePending(false);

    await dispatch(AssetsMiddleware.getUnlinkAssets());
  };

  useEffect(() => {
    if (!afterDispatch) setOpen(false);
  }, [!afterDispatch]);

  const onGetDetail = (id) => {
    dispatch(AssetsMiddleware.getSingleAssetsDetails(id)).then((data) => {
      setDetails(data?.data?.data);
      setOpen(true);
    });
  };

  const onExportAssest = async () => {
    await dispatch(AssetsMiddleware.exportAssets()).then((data) => {
      const url = data?.data?.data?.url;
      if (url) {
        window.open(url, "_blank");
      }
    });
  };

  const onimportUnprotectedAssets = () => {
    dispatch(AssetsMiddleware.importUnprotectedAssets()).then((data) => {
      setActivePending(false);
    });
  };
  const onDeletePending = (data) => {
    dispatch(AssetsMiddleware.deletePendingAssets({ id: data?.id })).then(
      () => {
        setActivePending(false);
      },
    );
  };
  const pagecalculation = () => {
    if (!getUnlinkAssets?.meta) {
      return 0;
    }

    return (
      (getUnlinkAssets?.meta?.current_page - 1) *
      getUnlinkAssets?.meta?.per_page
    );
  };

  const items2 = [
    {
      key: "3",
      label: <a onClick={() => setOpenEditAssetsModal(true)}>Edit details</a>,
    },
    {
      key: "4",
      label: (
        <a
          onClick={() => {
            setOpen(false);
            setDeleteModal(true);
          }}
        >
          Delete vehicle
        </a>
      ),
    },
  ];

  const PendingDelete = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, data, index) => (
        <div className={styles.dealerDiv}>
          <SubmitButton
            title={"Delete Pending"}
            className={styles.deleteBtn}
            onClick={() => {
              onDeletePending(data);
            }}
          />
        </div>
      ),
    },
  ];

  const dummydata = [
    {
      id: 1,
      key: "01",
      module: { image: md1, name: "Honda" },
      version: "Accord LX",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
    {
      id: 2,
      key: "02",
      module: { image: md2, name: "Toyota" },
      version: "Camry SE",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },

    {
      id: 3,
      key: "03",
      module: { image: md3, name: "Ford" },
      version: "F-150 XLT",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
    {
      id: 4,
      key: "04",
      module: { image: md4, name: "Chevrolet" },
      version: "Silverado LT",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
    {
      id: 5,
      key: "05",
      module: { image: md5, name: "Jeep" },
      version: "Wrangler Sport",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },

    {
      id: 6,
      key: "06",
      module: { image: md3, name: "Nissan" },
      version: "Rogue S",
      year: "2023",
      License_Plate: " HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent
            text={`${pagecalculation() + index + 1}`}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "Pic",
      dataIndex: "image",
      key: "image",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.image ? data?.image : imagePlaceholder}
            className={styles.moduleImg}
          />
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => (
        <div className={styles.module}>
          <TextComponent text={data ? data : "-"} className={styles.text} />
        </div>
      ),
    },
    {
      title: "Stock",
      dataIndex: "stock_no",
      key: "stock_no",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "VIN",
      dataIndex: "vin_no",
      key: "vin_no",
      render: (text) => {
        const lastEight = text ? text.toString().slice(-8) : "-";

        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={lastEight} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Make",
      dataIndex: "image",
      key: "image",
      render: (item, data) => (
        <div className={styles.module}>
          <TextComponent
            text={data?.make ? data?.make : "-"}
            className={styles.text}
          />
        </div>
      ),
    },

    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      render: (text) => (
        <div>
          <TextComponent
            text={text ? text : "-"}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Odometer",
      dataIndex: "odometer",
      key: "odometer",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Day In Inventory",
      dataIndex: "days_in_inventory",
      key: "days_in_inventory",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Lot Name",
      dataIndex: "lot",
      key: "lot",
      render: (item, data) => {
        return (
          <div className={styles.carDiv} onClick={(e) => e.stopPropagation()}>
            <Drop
              value={data?.lot?.name}
              inputClass={styles.carDropDown}
              options={lot_numbers?.map((lot) => ({
                value: lot?.name,
                id: lot?.id,
              }))}
              onChange={(e) => {
                dispatch(
                  AssetsMiddleware.updateAssetLot({
                    lot_id: e?.id,
                    id: data?.id,
                  }),
                );
              }}
              disabled={
                (lot_name == undefined || lot_name?.is_access == 0) &&
                !user?.is_owner
              }
            />
          </div>
          // <div className={styles.dealerDiv}>
          //   <TextComponent
          //     text={data?.lot?.name ? data?.lot?.name : "-"}
          //     className={styles.text}
          //   />
          // </div>
        );
      },
    },
    // {
    //   title: "Year",
    //   dataIndex: "year",
    //   key: "battery",
    //   render: (text) => (
    //     <div className={styles.batteryDiv}>
    //       {/* <img src={item?.image} className={styles.moduleImg} /> */}
    //       {/* <BatteryStatus percentage={text} /> */}
    //       <TextComponent text={text} className={styles.text} />
    //     </div>
    //   ),
    // },
    {
      title: "License Plate",
      dataIndex: "license_no",
      key: "license_no",
      render: (text) => (
        <div className={styles.carDiv}>
          <TextComponent text={text ? text : "-"} className={styles.text} />
        </div>
      ),
    },

    {
      title: "Trim",
      dataIndex: "trim",
      key: "trim",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },

    // {
    //   title: "Track",
    //   dataIndex: "track",
    //   key: "track",
    //   render: (text) => (
    //     <div
    //       className={styles.trackDiv}
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         // setLocationTracking(true);
    //       }}
    //     >
    //       {text}
    //     </div>
    //   ),
    // },
  ];

  const baseButtons = [
    {
      title: "Add vehicle",
      onClick: () => setOpenAddAssetsModal(true),
    },
    {
      title: "Add vehicle group",
      onClick: () => setOpenAddGroupAsset(true),
    },
    {
      title: "Upload vehicle",
      onClick: () => setOpenUploadAsset(true),
    },
  ];

  const buttons =
    reports?.is_access === 0
      ? baseButtons
      : [
          ...baseButtons,
          {
            title: "Export vehicle",
            onClick: onExportAssest,
          },
        ];

  return (
    <>
      <div className={styles.tableHeader}>
        {/* <div
          className={styles.importBtn}
          onClick={(e) => {
            e.stopPropagation();
            handlePendingToggle();
          }}
          style={{
            backgroundColor: activePending
              ? "var(--secondary-color)"
              : "var(--light-grey)",
            opacity: activePending ? 0.8 : 1,
            // cursor: activePending ? "not-allowed" : "pointer",
          }}
          // disabled={activePending}
        >
          <MdPending title={"Pending"} />
          <TextComponent text={"Pending"} />
        </div> */}
        <div
          className={styles.importBtn}
          onClick={(e) => {
            e.stopPropagation();
            onimportUnprotectedAssets();
          }}
        >
          <RiRefreshLine title={"Refresh"} />
          <TextComponent text={"Refresh"} />
        </div>
        {user?.is_owner || add_asset?.is_access == 1 ? (
          <FloatingButton
            Buttons={buttons}
            floatStyle={styles.floatingBtn}
            buttonStyles={styles.floatingButtonsContainer}
          />
        ) : null}
      </div>
      <div className={styles.tableDiv}>
        <Table
          //   title={}
          scroll={{ x: true }}
          bordered={false}
          pagination={{
            showSizeChanger: false,
            showQuickJumper: false,
            current: getUnlinkAssets?.meta?.current_page,
            pageSize: getUnlinkAssets?.meta?.per_page,
            total: getUnlinkAssets?.meta?.total,
            onChange: (page, pageSize) => {
              dispatch(
                AssetsMiddleware.getUnlinkAssets({
                  url: `${getUnlinkAssets?.meta?.path}?page=${page}`,
                }),
              );
            },
            itemRender: (_, type, originalElement) => {
              if (type === "prev") {
                return (
                  <span
                    style={{
                      color: getUnlinkAssets?.links?.prev ? "inherit" : "#ccc",
                      cursor: getUnlinkAssets?.links?.prev
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => {
                      dispatch(
                        AssetsMiddleware.getUnlinkAssets({
                          // name: search,
                          url: getUnlinkAssets?.links?.prev,
                        }),
                      );
                    }}
                  >
                    <LeftOutlined /> Prev
                  </span>
                );
              }
              if (type === "next") {
                return (
                  <span
                    style={{
                      color: getUnlinkAssets?.links?.next ? "inherit" : "#ccc",
                      cursor: getUnlinkAssets?.links?.next
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => {
                      dispatch(
                        AssetsMiddleware.getUnlinkAssets({
                          // name: search,
                          url: getUnlinkAssets?.links?.next,
                        }),
                      );
                    }}
                  >
                    Next <RightOutlined />
                  </span>
                );
              }
              return originalElement;
            },
          }}
          columns={activePending ? [...columns, ...PendingDelete] : columns}
          dataSource={getUnlinkAssets?.data}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => !activePending && onGetDetail(record?.id),
              style: { cursor: "pointer" },
            };
          }}
        />
        <Drawer
          width={width < 550 ? "100%" : 600}
          headerStyle={{ display: "none" }}
          onClose={() => {
            setOpen(false);
            setDetails([]);
          }}
          open={open}
        >
          {/* <div className={styles.drawerImgDiv}> */}
          {/* <img src={c6} className={styles.drawerImg} /> */}
          <div
            className={styles.crossIconDiv}
            onClick={() => {
              setOpen(false);
              setDetails([]);
            }}
          >
            <IoClose />
            {/* </div> */}
          </div>
          <div className={styles.rightCol}>
            <Card>
              <img
                src={details?.image || imagePlaceholder}
                alt=""
                className={styles.slectedImg}
              />
              <div className={styles.leftHeader}>
                <div>
                  {details?.name && (
                    <TextComponent
                      text={`${details?.name ? details?.name : "-"}`}
                      className={styles.heading}
                    />
                  )}
                  {details?.make && (
                    <TextComponent
                      text={`${details?.make ? details?.make : "-"} `}
                      className={styles.heading}
                    />
                  )}
                  {details?.license_no && (
                    <TextComponent
                      text={`License Plate: ${details?.license_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.vin_no && (
                    <TextComponent
                      text={`VIN: ${details?.vin_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.model && (
                    <TextComponent
                      text={`Model: ${details?.model}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.dealer_name && !user?.is_owner && (
                    <TextComponent
                      text={`Dealer Name: ${details?.dealer_name}`}
                      className={styles.carDescText}
                    />
                  )}
                  {/* <TextComponent text={"2016"] className={styles.carDescText} /> */}
                  {/* <TextComponent
                  text={"Location: Lot A, Row 5"}
                  className={styles.carDescText}
                /> */}
                </div>
                <div>
                  {details?.color && (
                    <TextComponent
                      text={`Color: ${details?.color}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.trim && (
                    <TextComponent
                      text={`Trim: ${details?.trim}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.stock_no && (
                    <TextComponent
                      text={`Stock No: ${details?.stock_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.year && (
                    <TextComponent
                      text={`Year: ${details?.year}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.lot?.name && (
                    <TextComponent
                      text={`Lot Name: ${details?.lot?.name}`}
                      className={styles.carDescText}
                    />
                  )}
                </div>
                {user?.is_owner || add_asset?.is_access == 1 ? (
                  <div>
                    <Dropdown
                      trigger={"click"}
                      menu={{
                        items: items2,
                      }}
                      placement="bottomRight"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <button className={styles.menubtn}>
                        <SlOptionsVertical
                          size={20}
                          color="var(--light-text)"
                          cursor={"pointer"}
                        />
                      </button>
                    </Dropdown>
                  </div>
                ) : null}
              </div>
              {user?.is_owner ||
              // add_asset?.is_access == 1 &&
              pair_unpair_device?.is_access == 1 ? (
                <div
                  className={styles.assetBtn}
                  onClick={() => setConnectModal(true)}
                >
                  <AiFillPlusCircle
                    size={18}
                    color="var(--secondary-color)"
                    style={{ marginRight: "5px" }}
                  />
                  <TextComponent text={"Connect"} className={styles.btnTxt} />
                </div>
              ) : null}
            </Card>
          </div>
        </Drawer>
        <ConnectModule
          connectModal={connectModal}
          setConnectModal={setConnectModal}
          details={details}
          afterDispatch={setAfterDispatch}
          setOpen={setOpen}
          user={user}
        />
        <AddAssets
          isOpen={openAddAssetsModal}
          setIsOpen={setOpenAddAssetsModal}
          setActiveTab={setActiveTab}
        />
        <EditAssets
          isOpen={openEditAssetsModal}
          setIsOpen={setOpenEditAssetsModal}
          details={details}
          afterDispatch={setAfterDispatch}
          setDrawerState={setOpen}
        />
        <AddGroupAssetModal
          isOpen={openAddGroupAsset}
          setIsOpen={setOpenAddGroupAsset}
        />
        <UploadAssets
          isOpen={openUploadAsset}
          setIsOpen={setOpenUploadAsset}
          afterDispatch={setAfterDispatch}
        />
        <Modal
          open={deleteModal}
          onCancel={() => {
            setDeleteModal(false);
          }}
          icon={
            <AiOutlineQuestionCircle
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          twoButton
          okBtnTitle={"Yes, delete"}
          cancelBtnTitle={"No, go back"}
          title={"Are you sure"}
          text={"You want to delete this vehicle?"}
          width={400}
          // btnDiv={styles.access_modalBtn}
          onClickCancelButton={() => {
            setDeleteModal(false);
          }}
          onClickOkButton={
            () => {
              dispatch(AssetsMiddleware.deleteAssets(details?.id)).then(() => {
                setDeleteModal(false);
                setSuccess(true);
              });
            }
            //   () => {
            //   setSuccess(true);
            //   setDeleteModal(false);
            // }
          }
          headingClass={styles.modalHeading}
        ></Modal>
        <Modal
          open={success}
          onCancel={() => setSuccess(false)}
          icon={
            <PiSealCheck
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          title={"Vehicle Deleted successfully"}
          width={"300px"}
          buttonTitle={"Continue"}
          onBtnPress={() => {
            setSuccess(false);
          }}
          headingClass={styles.modalHeading}
        ></Modal>
      </div>
    </>
  );
};

export default Unlink;
